import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_user/summits")({
  staticData: { title: "Summits" },
  component: () => <Outlet />,
});
